import { useEffect, useState } from "react";
import Alert from "../alert/Alert";

interface ToastProps {
  variant: "success" | "error" | "warning" | "info";
  title: string;
  message: string;
  duration?: number; // ms
  position?: "top-right" | "bottom-right";
  onClose?: () => void;
}

const Toast = ({
  variant,
  title,
  message,
  duration = 4000,
  position = "top-right",
  onClose
}: ToastProps) => {
  const [visible, setVisible] = useState(true);

    useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose?.(); // Call onClose when hiding
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!visible) return null;

  const positionClasses =
    position === "top-right"
      ? "top-6 right-6"
      : "bottom-6 right-6";

  return (
    <div className={`fixed z-50 ${positionClasses} w-[360px]`}>
      <Alert variant={variant} title={title} message={message} />
    </div>
  );
};

export default Toast;